"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveFocalPointCoordinates = exports.calculateDimensions = void 0;
var types_1 = require("./types");
/**
 * This function calculates the dimensions according the following logic:
 * 1. Given fixed dimensions => returns them as are
 * 2. Given fixed dimensions and an aspect ratio => returns the original width and calculates the height
 * 3. Given one fixed dimension and an aspect ratio => returns the original given dimension and calculates the missing one
 * 4. Otherwise => returns `null`
 */
function calculateDimensions(_a) {
    var width = _a.width, height = _a.height, aspectRatio = _a.aspectRatio;
    if (!(width && height) && !((width || height) && aspectRatio)) {
        return null;
    }
    var calculatedWidth = width, calculatedHeight = height;
    if (aspectRatio) {
        if (width) {
            calculatedHeight = Math.round(width / aspectRatio);
        }
        else {
            calculatedWidth = Math.round(height * aspectRatio);
        }
    }
    return { width: calculatedWidth, height: calculatedHeight };
}
exports.calculateDimensions = calculateDimensions;
/**
 * This function resolves the focal point coordinates according the following logic:
 * 1. Given a preset string => returns its coordinates
 * 2. Given an incorrect preset string => returns `null`
 * 3. Otherwise => returns the given coordinates
 */
function resolveFocalPointCoordinates(focalPoint) {
    if (typeof focalPoint === 'string') {
        return types_1.FocalPointPresets[focalPoint] || null;
    }
    return focalPoint;
}
exports.resolveFocalPointCoordinates = resolveFocalPointCoordinates;
//# sourceMappingURL=ImageUtils.js.map